import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
// TODO move the whole list-view component to feature/shared/list-view
// eslint-disable-next-line @nx/workspace/enforce-domain-boundaries
import { OrgScopeStorageService } from '@y42/org';
import { switchMap } from 'rxjs';
import { QuickFilterModel } from './model/quick-filter.model';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class JsonStorageService {
  constructor(private readonly orgScopeStorageService: OrgScopeStorageService) {}

  getStorageByKey(key: string) {
    return this.orgScopeStorageService.load<QuickFilterModel[]>(key).pipe(untilDestroyed(this));
  }

  createStorageByKey(key: string, data: QuickFilterModel[]) {
    return this.orgScopeStorageService.save<QuickFilterModel[]>(key, data).pipe(untilDestroyed(this));
  }

  deleteStorageByKey(key: string) {
    return this.orgScopeStorageService.delete(key).pipe(untilDestroyed(this));
  }

  addQuickFilter(filter: QuickFilterModel, quickFilterLocation: string) {
    return this.getStorageByKey(quickFilterLocation).pipe(
      switchMap((filters) => this.createStorageByKey(quickFilterLocation, [...filters, filter])),
    );
  }

  updateQuickFilter(id: number | string, data: QuickFilterModel, quickFilterLocation: string) {
    return this.getStorageByKey(quickFilterLocation).pipe(
      switchMap((filters) => {
        const index = filters.findIndex((res) => res.id === id);
        if (index !== -1) {
          filters[index] = data;
        }
        return this.createStorageByKey(quickFilterLocation, filters);
      }),
    );
  }

  deleteQuickFilter(id: number | string, quickFilterLocation: string) {
    return this.getStorageByKey(quickFilterLocation).pipe(
      switchMap((filters) => {
        const indexDelete = filters.findIndex((res) => res.id === id);
        if (indexDelete !== -1) {
          filters.splice(indexDelete, 1);
        }
        return this.createStorageByKey(quickFilterLocation, filters);
      }),
    );
  }
}
